import { render, staticRenderFns } from "./KEditor.vue?vue&type=template&id=cae1f272&scoped=true"
import script from "./KEditor.vue?vue&type=script&lang=js"
export * from "./KEditor.vue?vue&type=script&lang=js"
import style0 from "./KEditor.vue?vue&type=style&index=0&id=cae1f272&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae1f272",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cae1f272')) {
      api.createRecord('cae1f272', component.options)
    } else {
      api.reload('cae1f272', component.options)
    }
    module.hot.accept("./KEditor.vue?vue&type=template&id=cae1f272&scoped=true", function () {
      api.rerender('cae1f272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/helper/KEditor.vue"
export default component.exports